import React from 'react'

import './styles/go_landscape.css';

import rotate from "./imgs/rotate.png";

const GoLandscape = ({ message }) => {
  return (
    <div className='go-landscape-BG'>
        <div className='message-container'>
        <div className='image'>
            <img src={ rotate } alt='rotate device'/>
        </div>
        <div className='message'>
            <p>{ message }</p>
        </div>
        </div>
        
    </div>
  )
}

export default GoLandscape